import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from '../theme/theme';
import { FeedbackProvider } from './FeedbackProvider';
import { PrescriberProvider } from './PrescriberProvider';
import { AuthProvider } from './AuthProvider';
import { AssistantProvider } from './AssistantProvider';

interface CombinedProvidersProps {
  children: JSX.Element;
}

function CombinedProviders(props: CombinedProvidersProps) {
  return (
    <ChakraProvider theme={theme}>
      <FeedbackProvider>
        <AuthProvider>
          <AssistantProvider>
            <PrescriberProvider>{props.children}</PrescriberProvider>
          </AssistantProvider>
        </AuthProvider>
      </FeedbackProvider>
    </ChakraProvider>
  );
}

export default CombinedProviders;
